import type { IStudioGame, IStudioHeader } from '@/pages/home/pages/studio/type';

/**
 * PR 枢纽兜底游戏：当 studio info 未返回 game_list 时，左侧侧栏与页面内 game_list 均使用此列表。
 * 与 PrStudioMonthFilter 中 getPrGamesWithChannels 的 unified_edition_ids 兜底保持一致。
 * 非业务配置，不要扩充；如需调整请联系 owner。
 */
export const PR_HUB_FALLBACK_GAMES: IStudioGame[] = [
  {
    game_code: 'dune',
    unified_game_code: 'dune_awakening_unified',
    game_name: 'Dune: Awakening',
    game_name_cn: 'Dune: Awakening',
    game_area: '',
    game_type: 'pc',
    id_type: 'edition_id',
    unified_edition_id: 'e76337e746e1f95fdbf7e23c26010e448',
    cover: 'https://ogdb-cdn.intlgame.cn/image/063a2695b10a5d50c9d64043db59e71e.jpg',
    background_url: 'https://ogdb-cdn.intlgame.com/front/static/img/studio/dune-awakening-b.png',
    developer: '',
    publisher: '',
    utc_offset: '+0',
    edition: 'major',
    studio_code: 'funcom',
    game_tags: [],
    dashboard_list: [],
    dashboard_research_list: [],
    pc_path_access_list: [],
  },
  {
    game_code: 'funcom',
    unified_game_code: 'funcom_unified',
    game_name: 'Conan',
    game_name_cn: 'Conan',
    game_area: 'GLOBAL',
    game_type: 'pc',
    id_type: 'edition_id',
    unified_edition_id: 'efc7a5eee1d6ca668931bcebf69198b60',
    cover: 'https://ogdb-cdn.intlgame.cn/image/2e32d8ca437ff64789d99ea17ea7f4c9.jpg',
    background_url: 'https://ogdb-cdn.intlgame.com/front/static/img/studio/conan-exiles-b.png',
    developer: 'funcom',
    publisher: 'funcom',
    utc_offset: ' +0',
    edition: 'minor',
    studio_code: 'funcom',
    game_tags: [],
    dashboard_list: [],
    dashboard_research_list: [],
    pc_path_access_list: [],
  },
  {
    game_code: 'aloft',
    unified_game_code: 'aloft_unified',
    game_name: 'ALOFT',
    game_name_cn: 'Aloft',
    game_area: '',
    game_type: 'pc',
    id_type: 'edition_id',
    unified_edition_id: 'e810adf63493382eb2999280fccd92c24',
    cover: 'https://ogdb-cdn.intlgame.cn/image/9ef90a5120d9c2b42263d56434d0648a.jpg',
    background_url:
      'https://ogdb-cdn.intlgame.cn/aupload/admin/studio_hub/image/1741143945787_Aloft_EA_Launch_Gazebo_4K.png',
    developer: '',
    publisher: '',
    utc_offset: '+0',
    edition: 'major',
    studio_code: 'funcom',
    game_tags: [],
    dashboard_list: [],
    dashboard_research_list: [],
    pc_path_access_list: [],
  },
];

export const PR_HUB_FALLBACK_UNIFIED_EDITION_IDS = PR_HUB_FALLBACK_GAMES.map(
  (g) => g.unified_edition_id,
);

/** studio info 未配置 game_list 时，PR/AI 枢纽需启用兜底游戏 */
export function needsPrHubFallbackGameList(studioData?: IStudioHeader | null): boolean {
  return !studioData?.game_list?.length;
}

/** 在 game_list 为空时合并兜底游戏，供侧栏、路由补全与页面内 studioData 使用 */
export function applyPrHubFallbackGameList(
  studioData?: IStudioHeader | null,
): IStudioHeader | undefined {
  if (!studioData) {
    return studioData;
  }
  if (studioData.game_list?.length) {
    return studioData;
  }
  return {
    ...studioData,
    game_list: PR_HUB_FALLBACK_GAMES,
  };
}
